import { atom, useAtom, useSetAtom } from "jotai";

export const tableScreenLayout = atom(1);
const useTableScreenLayout = () => {
  const atom = useAtom(tableScreenLayout);
  return atom;
};

export const useSetTableScreenLayout = () => useSetAtom(tableScreenLayout);

export default useTableScreenLayout;
